import { UserDropdownComponent } from '@leagueplatform/web-common-components';
import {
  SCREEN_NAMES,
  PRODUCT_AREA,
  EVENT_NAME,
} from '@leagueplatform/analytics';
import { useUserDropdownComponent } from 'components/header-nav/navbar/user-dropdown/user-dropdown.hook';
import { getUserOptionAnalyticsProps } from 'utils/analytics-events';
import { Box } from '@leagueplatform/genesis-core';

interface Props {
  handleDeleteAccount: () => void;
}

const userBarAnalytics = {
  name: EVENT_NAME.BUTTON_CLICKED,
  props: {
    product_area: PRODUCT_AREA.SETTINGS,
    screen_name: SCREEN_NAMES.HOME,
    detail: 'open settings menu',
  },
};

export const UserDropdown = ({ handleDeleteAccount }: Props) => {
  const { data } = useUserDropdownComponent(handleDeleteAccount);

  // Transform the menu items to only add icons for external links
  const transformedMenuItemsConfig = data.menuItemsConfig.map((section) => ({
    ...section,
    items: section.items.map((item) => {
      // Only add icon for external links
      if (item.linkIcon === 'interfaceExternalLink') {
        return {
          ...item,
          icon: 'interfaceExternalLink',
        };
      }
      return item;
    }),
  }));

  return (
    <Box
      css={{
        margin: 'auto 0',
        '#user_dropdown_menu button': {
          fontWeight: '700',
          '&:focus::before': {
            outline: 'none',
            boxShadow: 'none',
          },
        },
        '#user_dropdown_menu li': {
          marginBottom: '4px',
          '&:last-child': {
            marginBottom: '0',
          },
        },
        '#user_dropdown_menu ul': {
          '& > li': {
            marginBottom: '4px',
            'a > div': {
              justifyContent: 'space-between',
            },
            '&:last-child': {
              marginBottom: '0',
            },
          },
        },
      }}
    >
      <UserDropdownComponent
        label={data.preferredFirstName.toUpperCase()}
        dropdownItemsConfig={transformedMenuItemsConfig.map(
          (section) => section.items,
        )}
        userBarAnalyticsProps={userBarAnalytics}
        getDropdownItemAnalyticsProps={getUserOptionAnalyticsProps}
      />
    </Box>
  );
};
